var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_4693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.73047 6.27497C2.73047 5.32273 3.50242 4.55078 4.45466 4.55078H10.4893C11.4416 4.55078 12.2135 5.32273 12.2135 6.27497V11.4475C12.2135 12.3998 11.4416 13.1717 10.4893 13.1717H4.45466C3.50242 13.1717 2.73047 12.3998 2.73047 11.4475V6.27497Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45703 12.3086H6.18146V13.1708C6.18146 13.647 5.79544 14.033 5.31925 14.033Lnan nanL5.31925 14.033C4.84306 14.033 4.45703 13.647 4.45703 13.1708V12.3086Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76562 12.3086H10.4901V13.1708C10.4901 13.647 10.104 14.033 9.62784 14.033Lnan nanL9.62784 14.033C9.15165 14.033 8.76562 13.647 8.76562 13.1708V12.3086Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61044 2.60973C6.49139 2.60973 6.39489 2.70624 6.39489 2.82528V4.98082C6.39489 5.33796 6.10537 5.62748 5.74822 5.62748C5.39108 5.62748 5.10156 5.33796 5.10156 4.98082V2.82528C5.10156 1.99195 5.77711 1.31641 6.61044 1.31641H8.33487C9.1682 1.31641 9.84375 1.99195 9.84375 2.82528V4.98082C9.84375 5.33796 9.55423 5.62748 9.19708 5.62748C8.83994 5.62748 8.55042 5.33796 8.55042 4.98082V2.82528C8.55042 2.70624 8.45392 2.60973 8.33487 2.60973H6.61044Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31641 7.56641H9.62748",
    stroke: "white",
    strokeWidth: 0.862155,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31641 10.582H9.62748",
    stroke: "white",
    strokeWidth: 0.862155,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_4693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3501,
    height: 14.3501,
    fill: "white",
    transform: "translate(0.300781 0.519531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.a3b99448eb9d27f86e92d3fbc42393a0.svg";
export { ForwardRef as ReactComponent };